<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {getHistory} from 'src/components/cabinet/#services/vesting'
    import {myRole} from "src/components/#common/myRole"
    import IconifyIcon from '@iconify/svelte'
    import {Table} from "sveltestrap"
    import loadingIcon from '@iconify/icons-fa-solid/spinner'
    import lockIcon from '@iconify/icons-fa-solid/lock'
    import unlockIcon from '@iconify/icons-fa-solid/unlock'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'

    let currentPage = 0
    let perPage = 50

    function init() {
        getHistory.send({ data: { page: currentPage + 1, perPage } })
        $getHistory.value
    }

    $:currentPage, perPage, init()

    function roundNumber(number: number) {
        return Math.round((number + Number.EPSILON) * 100) / 100
    }

    function numberWithSpaces(number) {
        let parts = number.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        return parts.join('.')
    }
</script>

<svelte:head>
    <title>History</title>
</svelte:head>

<MainLayout title="History">
    <svelte:fragment slot="content">
        <div class="card card-body">
            {#if $myRole.hasValue && $myRole?.value?.name === 'SuperAdmin'}
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <td class="text-center">Wallet</td>
                            <td class="text-center">Amount</td>
                            <td class="text-center">Start Date</td>
                            <td class="text-center">End date</td>
                            <td class="text-center">Status</td>
                        </tr>
                    </thead>
                    <tbody>
                    {#if !$getHistory.hasValue && $getHistory.loading}
                        <tr>
                            <td class="text-center" colSpan="5">Loading...</td>
                        </tr>
                    {:else if !$getHistory.hasValue && $getHistory.error }
                        <tr>
                            <td class="text-center" colspan="5">Something went wrong. Try refreshing the page.</td>
                        </tr>
                    {:else if $getHistory.value}
                        {#each $getHistory.value.data as { id, accountId, amount, partOfTheAmount, interval, depositAt, isLockup }}
                            <tr>
                                <td class="text-center">
                                    <span title={accountId}>
                                        {#if accountId.length > 30}
                                            {accountId.slice(0, 15)}...{accountId.slice(-15)}
                                        {:else}
                                            {accountId}
                                        {/if}
                                    </span>
                                </td>
                                <td class="text-center">
                                    {numberWithSpaces(roundNumber(+partOfTheAmount))} LIS
                                </td>
                                <td class="text-center">
                                    {new Date(+depositAt).toLocaleString()}
                                </td>
                                <td class="text-center">
                                    {new Date(+interval).toLocaleString()}
                                </td>
                                <td class="text-center">
                                    {#if isLockup === null}
                                        <IconifyIcon icon={loadingIcon} class="orange-color"/>
                                    {:else if isLockup}
                                        <IconifyIcon icon={lockIcon} class="red-color"/>
                                    {:else}
                                        <IconifyIcon icon={unlockIcon} class="green-color"/>
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    {/if}
                    </tbody>
                </Table>
                {#if $getHistory.hasValue}
                    <Pagination
                        bind:currentPage={currentPage}
                        totalCount={$getHistory.value.totalCount}
                        {perPage}
                        disabled={$getHistory.loading}
                    />
                {/if}
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    td :global(.red-color) {
        color: #f44336;
    }

    td :global(.orange-color) {
        color: #f48536;
    }

    td :global(.green-color) {
        color: #4caf50;
    }
</style>
